<div class="{{id}}" class="progress">
    <span id="progress-value">{{getProgress}}% </span>
  </div>
